import { makeStyles } from '@alpha/ui-lib/theme';

export const useStyles = makeStyles(
  () => ({
    wrapper: {
      display: 'flex',
      justifyContent: 'right',
      marginRight: 15,
    },
  }),
  { name: 'ActionDropDown' },
);

export default useStyles;
